"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenizeBankAccount = void 0;
function tokenizeBankAccount(routingNumber, accountNumber, config) {
    return fetch(config.cardConnectBaseUrl + "/cardsecure/api/v1/ccn/tokenize", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            account: routingNumber + "/" + accountNumber,
            unique: true,
        }),
    }).then(function (response) { return response.json(); });
}
exports.tokenizeBankAccount = tokenizeBankAccount;
